// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Legenda_container__xeb45 {
    background-color: transparent;
    position: absolute;
    width: 100%;
    margin: auto;
}

.Legenda_ul__XvYfR {
    background-color: transparent !important;
    list-style-type: none;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
}


.Legenda_states__KxD-u{
    display: grid;
    grid-template-columns: 20% 80%;
    background-color: transparent !important;
}

.Legenda_ul__XvYfR li {
    align-items: center;
    display: flex;
}

.Legenda_container__xeb45 {
    top: 75px;
    height: fit-content;
    width: 180px;
    right: 5px;
    margin: auto;
}

.Legenda_ul__XvYfR li {
    font-size: 15px;
    width: 80px;
}

ul {
    padding-left: 12px !important;
}

.Legenda_tooltip__CcALa, .Legenda_legendaBtn__DR2TI{
    margin:10px 10px 0 0;
    float: right !important;
}

/*DESKTOP */
@media screen and (min-width:1024px) {
    
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px){
    
}

/*MOBILE*/
@media screen and (max-width:767px){
    
}`, "",{"version":3,"sources":["webpack://./src/components/legenda/Legenda.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA,WAAW;AACX;;AAEA;;AAEA,SAAS;AACT;;AAEA;;AAEA,SAAS;AACT;;AAEA","sourcesContent":[".container {\n    background-color: transparent;\n    position: absolute;\n    width: 100%;\n    margin: auto;\n}\n\n.ul {\n    background-color: transparent !important;\n    list-style-type: none;\n    overflow: hidden;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n\n.states{\n    display: grid;\n    grid-template-columns: 20% 80%;\n    background-color: transparent !important;\n}\n\n.ul li {\n    align-items: center;\n    display: flex;\n}\n\n.container {\n    top: 75px;\n    height: fit-content;\n    width: 180px;\n    right: 5px;\n    margin: auto;\n}\n\n.ul li {\n    font-size: 15px;\n    width: 80px;\n}\n\nul {\n    padding-left: 12px !important;\n}\n\n.tooltip, .legendaBtn{\n    margin:10px 10px 0 0;\n    float: right !important;\n}\n\n/*DESKTOP */\n@media screen and (min-width:1024px) {\n    \n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px){\n    \n}\n\n/*MOBILE*/\n@media screen and (max-width:767px){\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Legenda_container__xeb45`,
	"ul": `Legenda_ul__XvYfR`,
	"states": `Legenda_states__KxD-u`,
	"tooltip": `Legenda_tooltip__CcALa`,
	"legendaBtn": `Legenda_legendaBtn__DR2TI`
};
export default ___CSS_LOADER_EXPORT___;
